import React from 'react'
import ReactStars from 'react-rating-stars-component'
import { Link, useLocation } from 'react-router-dom'
import prodcompare from '../images/prodcompare.svg'
import wish from '../images/wish.svg'
import addcart from '../images/add-cart.svg'
import view from '../images/view.svg'
import watch from '../images/watch.jpg'
import acc from '../images/acc.jpg'

const ProductCard = ({grid}) => {
    const location = useLocation();
  return (
    <div className={` ${location.pathname==='/store'?`gr-${grid}`:"col-3"}`}>
        <Link to="/product/:id" className="product-card position-relative">
            <div className="wishlist-icon position-absolute">
                <button className='border-0 bg-transparent'>
                    <img src={wish} alt="wishlist" />
                </button>
            </div>
            <div className="product-image">
                <img src={watch} className='img-fluid' alt="productimage" />
                <img src={acc} className='img-fluid'  alt="productimage" />  
            </div>
            <div className="product-details">
                <h6 className="brand">Nike</h6>
                <h5 className="product-title">
                    Lorem ipsum, dolor sit
                </h5>
                <ReactStars count={5} size={24} activeColor="#ffd700" edit={true} value={3} />
                <p className={`description ${grid === 12?'d-blog':'d-none'}`}>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse expedita officiis sunt error magni totam natus dolor odit tempore fugit!
                </p>
                <p className="price">$100.00</p>
            </div>
            <div className="action-bar position-absolute">
                <div className="d-flex flex-column gap-15">
                    <button className='border-0 bg-transparent'>
                        <img src={prodcompare} alt="compare" />
                    </button>
                    <button className='border-0 bg-transparent'>
                        <img src={view} alt="view" />
                    </button>
                    <button className='border-0 bg-transparent'>
                        <img src={addcart} alt="addcart" />
                    </button>
                </div>
            </div>
        </Link>
    </div>
  )
}

export default ProductCard